module.exports = __webpack_public_path__ + "public/img/guozhen.78bd317a.png";